import { colorToRgba, tokenColor } from './utils/colors';
export var classic = {
    background_color: colorToRgba(tokenColor('pe-neutral-050')),
    background_primary_text_color: colorToRgba(tokenColor('pe-neutral-800')),
    background_secondary_text_color: colorToRgba(tokenColor('pe-neutral-800')),
    butterfly_chart_left_color: colorToRgba(tokenColor('pe-neutral-500')),
    butterfly_chart_right_color: colorToRgba(tokenColor('pe-blue-500')),
    chart_bar_color: colorToRgba(tokenColor('pe-blue-500')),
    chart_keyword_color: colorToRgba(tokenColor('pe-neutral-800')),
    chart_primary_text_color: colorToRgba(tokenColor('pe-neutral-800')),
    clicks_received_box_color: colorToRgba(tokenColor('pe-neutral-700')),
    clicks_received_text_color: colorToRgba(tokenColor('pe-neutral-050')),
    colorscheme_base_color: null,
    colorscheme_primary_background_color: null,
    colorscheme_primary_text_color: null,
    colorscheme_secondary_background_color: null,
    colorscheme_secondary_text_color: null,
    headerTransparent: true,
    header_bottom_background_color: colorToRgba(tokenColor('pe-blue-300')),
    header_title_color: colorToRgba(tokenColor('pe-neutral-700')),
    header_top_background_color: colorToRgba(tokenColor('pe-blue-300')),
    message_background_color: colorToRgba(tokenColor('pe-neutral-200')),
    pinned_message_background_color: colorToRgba(tokenColor('pe-neutral-100')),
    themeId: 'classic',
    voting_instructions_background_color: colorToRgba(tokenColor('pe-neutral-200')),
    voting_instructions_text_color: colorToRgba(tokenColor('pe-neutral-900'))
};
